import {Pipe, PipeTransform} from "@angular/core";
import {Product} from "./product";
import {Utils} from "../../shared/utils/utils";

@Pipe({
    name: 'sortProductsByFreeInstalled',
    standalone: false
})
export class SortProductsByFreeInstalledPipe implements PipeTransform {

  transform(products: Product[]): Product[] {
    return Utils.sort(products, (p1: Product, p2: Product): number => {


      const p1HasUpgrade: boolean = p1.installed && p1.hasPaidVersion && !p1.paidVersionInstalled;
      const p2HasUpgrade: boolean = p2.installed && p2.hasPaidVersion && !p2.paidVersionInstalled;
      return p1HasUpgrade === p2HasUpgrade ? 0 : (!p1HasUpgrade && p2HasUpgrade ? 1 : -1);
    });
  }

}
